import { render, staticRenderFns } from "./ship-icon.svg.vue?vue&type=template&id=565f725c&"
import script from "./ship-icon.svg.vue?vue&type=script&lang=js&"
export * from "./ship-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports